import {
  setTasksFulfilledAction,
  setTasksPendingAction,
  setTasksRejectedAction,
} from './actions/actions.ts';
import type {
  TTasksAdministrationTasksResponse,
  TTasksState,
  TTasksSupervisors,
  TTasksUakdoAccess,
} from './types.ts';
import type { AdministrationRole } from '~/modules/tasks/taskModels.ts';

export const handleFetchTasksAdministrationRolesPending = (state: TTasksState) => {
  setTasksPendingAction(state.administrationRoles);
};

export const handleFetchTasksAdministrationRolesFulfilled = (
  state: TTasksState,
  payload: AdministrationRole[]
) => {
  setTasksFulfilledAction(state.administrationRoles, payload);
};

export const handleFetchTasksAdministrationRolesRejected = (state: TTasksState, error: unknown) => {
  setTasksRejectedAction(state.administrationRoles, error);
};

export const handleFetchTasksAdministrationTasksPending = (state: TTasksState) => {
  setTasksPendingAction(state.administrationTasks);
};

export const handleFetchTasksAdministrationTasksFulfilled = (
  state: TTasksState,
  payload: TTasksAdministrationTasksResponse
) => {
  setTasksFulfilledAction(state.administrationTasks, payload);
};

export const handleFetchTasksAdministrationTasksRejected = (state: TTasksState, error: unknown) => {
  setTasksRejectedAction(state.administrationTasks, error);
};

export const handleFetchTasksUakdoAccessPending = (state: TTasksState) => {
  setTasksPendingAction(state.uakdoAccess);
};

export const handleFetchTasksUakdoAccessFulfilled = (
  state: TTasksState,
  payload: TTasksUakdoAccess
) => {
  setTasksFulfilledAction(state.uakdoAccess, payload);
};

export const handleFetchTasksUakdoAccessRejected = (state: TTasksState, error: unknown) => {
  setTasksRejectedAction(state.uakdoAccess, error);
};

export const handleFetchTasksSupervisorsPending = (state: TTasksState) => {
  setTasksPendingAction(state.taskSupervisors);
};

export const handleFetchTasksSupervisorsFulfilled = (
  state: TTasksState,
  payload: TTasksSupervisors
) => {
  setTasksFulfilledAction(state.taskSupervisors, payload);
};

export const handleFetchTasksSupervisorsRejected = (state: TTasksState, error: unknown) => {
  setTasksRejectedAction(state.taskSupervisors, error);
};

export const handleTasksPatchAssigneePending = (state: TTasksState) => {
  setTasksPendingAction(state.patchAssignee);
};

export const handleTasksPatchAssigneeFulfilled = (state: TTasksState, payload: unknown) => {
  setTasksFulfilledAction(state.patchAssignee, payload);
};

export const handleTasksPatchAssigneeRejected = (state: TTasksState, error: unknown) => {
  setTasksRejectedAction(state.patchAssignee, error);
};

export const handleTasksUpdateStatusPending = (state: TTasksState) => {
  setTasksPendingAction(state.updateStatus);
};

export const handleTasksUpdateStatusFulfilled = (state: TTasksState, payload: unknown) => {
  setTasksFulfilledAction(state.updateStatus, payload);
};

export const handleTasksUpdateStatusRejected = (state: TTasksState, error: unknown) => {
  setTasksRejectedAction(state.updateStatus, error);
};
